export default "__VITE_PUBLIC_ASSET__b3d125de__"